<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="middle-page-wrap">
   			        <h1 class="page-title"> Dashboard </h1>
   			        <div class="dashboard-block col-12">
				        <div class="row">
					        <div class="row">
						        <div class="dashboard-internal-block col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
							        <div class="dashboard-internal-box">
								        <div class="block-content-main">
									        <div class="block-content-img">
										        <img src="/static/images/profile-info.png" alt="Profile Info">
									        </div>
									        <div class="right-block-content">
                                                <h5> Profile Info </h5>
                                                <h6> {{loginCustomerName}} </h6>
                                                <p> {{loginCustomerAddressLine1}} 
                                                    <template v-if="loginCustomerAddressLine2 != ''">
                                                        {{loginCustomerAddressLine2}}
                                                    </template>
                                                     {{loginCustomerZipCode}}
                                                </p>
									        </div>
                                            <template v-if="!isUserLogin">
                                                <div class="block-common-btn">
                                                    <router-link  v-bind:to="{name: 'CustomerProfile'}"> Manage User Profile <span> <img src="/static/images/right-arrow-img.png" alt="Right Arrow"> </span> </router-link >
                                                </div>
                                            </template>
								        </div>
							        </div>
						        </div>
        				        <div class="dashboard-internal-block col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
          					        <div class="dashboard-internal-box">
            					        <div class="block-content-main">
              						        <div class="block-content-img">
                						        <img src="/static/images/my-order-cart-img.png" alt="My Order Cart">
              						        </div>
              						        <div class="right-block-content">
                						        <h5> My Orders </h5>
                						        <p> To view all the orders <br/> please click on the button below: </p>
              						        </div>
              						        <div class="block-common-btn">
                						        <a href="javascript:void(0)" v-on:click.prevent="goToOrderListWithOutFilters()"> View Orders 
											        <span>
												        <img src="/static/images/right-arrow-img.png" alt="Right Arrow">
											        </span>
										        </a>
              						        </div>
            					        </div>
          					        </div>
        				        </div>
						        <div class="dashboard-internal-block col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
							        <div class="dashboard-internal-box">
								        <div class="block-content-main">
									        <div class="block-content-img">
										        <img src="/static/images/invetory-list-img.png" alt="Inventory List">
									        </div>
									        <div class="right-block-content">
										        <h5> My Inventory List </h5>
										        <p> To view all the Inventory <br/> List  please click on the button below: </p>
									        </div>
									        <div class="block-common-btn">
										        <a href="javascript:void(0)" v-on:click.prevent="goToConsignedInventoryList()"> View Inventory List <span> <img src="/static/images/right-arrow-img.png" alt="Right Arrow"> </span> </a>
									        </div>
								        </div>
							        </div>
						        </div>
                                <div class="dashboard-internal-block col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
          					        <div class="dashboard-internal-box">
            					        <div class="block-content-main">
              						        <div class="block-content-img">
                						        <img src="/static/images/my-order-cart-img.png" alt="My Order Cart">
              						        </div>
              						        <div class="right-block-content">
                						        <h5> Audit Inventory </h5>
                						        <p> To view all the audit inventory <br/> please click on the button below: </p>
              						        </div>
              						        <div class="block-common-btn">
                						        <a href="javascript:void(0)" v-on:click.prevent="goToAuditInventoryList()"> View Audit Inventory 
											        <span>
												        <img src="/static/images/right-arrow-img.png" alt="Right Arrow">
											        </span>
										        </a>
              						        </div>
            					        </div>
          					        </div>
        				        </div>
					        </div>
				        </div>
			        </div>
		        </div>
                <!-- Card with Image -->
                <!-- <div class="cards-container">
                    <div class="title">My Orders</div>
                    <div class="col-4">
                        <div class="cards-block default-bx-shadow">
                            <div class="card">
                                <div class="card-body">
                                    <a href="javascript:void(0)" class="btn btn-primary" v-on:click.prevent="goToOrderListWithOutFilters()">View All</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="title">My Consigned Inventory List</div>
                    <div class="col-4">
                        <div class="cards-block default-bx-shadow">
                            <div class="card">
                                <div class="card-body">
                                    <a href="javascript:void(0)" class="btn btn-primary" v-on:click.prevent="goToConsignedInventoryList()">View All</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <customer-footer></customer-footer>
    </div>
</template>

<script>
    var self;
    import Vue from "vue";
    import CustomerFooter from "@/components/partials/CustomerFooter";
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from "../event-bus";
    import {HTTP} from '../../http-common';
    import vSelect from 'vue-select';
    import moment from 'moment';
    import timezone from 'moment-timezone';

    export default {
        components: {
            'customer-footer': CustomerFooter,
            'v-select': vSelect,
        },
        name: 'CustomerDashboard',
        mixins: [commonMixins],
        data () {
            return {
                loginCustomerName: "",
                loginCustomerAddressLine1: "",
                loginCustomerAddressLine2: "",
                loginCustomerZipCode: "",
                isUserLogin: false,
            }
        },
        beforeMount() {
            self = this;
            EventBus.$emit("customer-menu-selection-changed", "customer-cards");
        },
        mounted: function() {
            self.customerProtal();
            localStorage.setItem("usingDateRangeFilters", 'no');
            var customerObj = localStorage.getItem("customer_obj");
            //if user logged in than remove login button and registration button
            if (customerObj != null) {
                var userJson = JSON.parse(customerObj);
                self.loginCustomerName = userJson['name'];
                self.loginCustomerAddressLine1 = userJson['address_line_1'];
                self.loginCustomerAddressLine2 = userJson['address_line_2'];
                self.loginCustomerZipCode = userJson['zip_code'];
            }
            if(localStorage.getItem("login_role") == 'user') {
                self.isUserLogin = true;
            }
        },
        methods: {
            goToAuditInventoryList: function() {
                if(localStorage.getItem("login_role") == 'user' && !localStorage.getItem("customer_id")) {
                    self.showSAlert("Please Select Customer First", 'info', false); 
                    return false; 
                }
                self.$router.push({name:'CustomerAuditInventoryList'});
            },
            goToOrderListWithOutFilters: function() {
                if(localStorage.getItem("login_role") == 'user' && !localStorage.getItem("customer_id")) {
                    self.showSAlert("Please Select Customer First", 'info', false); 
                    return false; 
                }
                localStorage.setItem("usingDateRangeFilters", 'no');
                self.$router.push({name:'CustomerOrderHistory'});
            },
            goToConsignedInventoryList: function() {
                if(localStorage.getItem("login_role") == 'user' && !localStorage.getItem("customer_id")) {
                    self.showSAlert("Please Select Customer First", 'info', false); 
                    return false; 
                }
                localStorage.setItem("usingDateRangeFilters", 'no');
                self.$router.push({name:'ListInventory'});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Customer/CustomerDashboard.vue